import createComponent, { ComponentProps } from '../utils/createComponent';
export type SidenavBodyProps = ComponentProps;

const SidenavBody = createComponent({ name: 'SidenavBody' });

export default SidenavBody;
